export const jobs = {
  brand: 'OVERHEAR',
  landingTitle: 'Work with Overhear',
  landingTagline:
    'Call-outs, freelance roles and other ways to work with us on listening, place and digital artwork.',
  landingIntro:
    'Overhear commissions specialists, artists and organisations to help make work with communities. Open opportunities are listed below. You can save an application and come back to it before you submit.',
  openCallouts: 'Open call-outs',
  openRoles: 'Open roles',
  noOpenJobs: 'There are no open opportunities at the moment.',
  noOpenJobsHint: 'Please check back soon, or email hello@theoverhear.app.',
  viewBrief: 'Read the brief',
  apply: 'Apply',
  applyNow: 'Apply now',
  backToJobs: 'All opportunities',
  issuedBy: 'Issued by',
  programme: 'Programme',
  location: 'Location',
  timing: 'Timing',
  deadline: 'Deadline',
  contact: 'Contact',
  atAGlance: 'At a glance',
  closed: 'Closed',
  open: 'Open',
  callOut: 'Call-out',
  role: 'Role',
  applicationsClosed: 'Applications for this opportunity are now closed.',
  applyTitle: 'Apply',
  applyIntro:
    'Fill in the form below. You can save a draft and return later using this page — bookmark it after saving.',
  alreadySubmitted: 'This application has been submitted.',
  submittedTitle: 'Thank you',
  submittedBody:
    'Your application has been sent to Overhear. We will be in touch using the email you provided. A confirmation may also arrive by email shortly.',
  submittedReference: 'Your application reference is {{id}}.',
  saveDraft: 'Save draft',
  saving: 'Saving…',
  submitting: 'Submitting…',
  submit: 'Submit application',
  lastSaved: 'Draft saved {{time}}',
  unsavedChanges: 'Unsaved changes',
  bookmarkHint: 'Bookmark this page to come back to your draft.',
  draftSaved: 'Draft saved. Bookmark this page to come back to it.',
  contactDetails: 'Your details',
  applicantType: 'I am applying as',
  individual: 'An individual / freelancer',
  organisation: 'An organisation',
  nameLabel: 'Name',
  emailLabel: 'Email',
  organisationLabel: 'Organisation name',
  phoneLabel: 'Phone (optional)',
  websiteLabel: 'Website or CV link (optional)',
  privacyLabel:
    'I consent to Overhear Ltd storing this application in order to consider me for this opportunity, and to contacting me about it.',
  privacyHint: 'You can ask us to delete your data at any time by emailing hello@theoverhear.app.',
  questionsWelcome: 'Questions about the brief are welcome by email before the deadline.',
  adminPageTitle: 'Jobs & call-outs',
  adminPageSubtitle: 'Edit public listings and review applications from jobs.theoverhear.app',
  adminTitle: 'Job applications',
  adminSubtitle: 'Applications submitted through jobs.theoverhear.app',
  adminEmpty: 'No applications yet.',
  adminStatus: 'Status',
  adminDraft: 'Draft',
  adminSubmitted: 'Submitted',
  adminJob: 'Opportunity',
  adminApplicant: 'Applicant',
  adminUpdated: 'Updated',
  adminOpen: 'View',
  adminDownloadPdf: 'Download PDF',
  adminDownloadPdfs: 'Download {{count}} PDFs',
  adminPdf: 'PDF',
  adminPdfPreparing: 'Preparing PDF…',
  adminPdfDownloaded: 'PDF downloaded.',
  adminPdfsDownloaded: '{{count}} PDFs downloaded as a zip file.',
  adminPdfFailed: 'Could not create the PDF. Please try again.',
  adminPdfDocumentLabel: 'Job application',
  adminPdfReference: 'Reference',
  adminPdfSubmittedAt: 'Date submitted',
  adminPdfApplicant: 'Applicant',
  adminPdfApplyingAs: 'Applying as',
  adminPdfPhone: 'Phone',
  adminPdfWebsite: 'Website',
  adminPdfNotProvided: 'Not provided',
  adminPdfPrivacy: 'Consent',
  adminPdfPrivacyYes: 'Consent given to store this application and to be contacted about it.',
  adminPdfPrivacyNo: 'Consent to store this application has not been confirmed.',
  adminPdfOther: 'Other answers',
  adminPdfAnswers: 'Answers',
  adminPdfConfidential: 'Confidential. Overhear Ltd',
  adminPdfPage: 'Page {{current}}',
  adminAllJobs: 'All opportunities',
  adminListingsTab: 'Opportunities',
  adminApplicationsTab: 'Applications',
  adminListingsHint: 'These listings appear on jobs.theoverhear.app. Edit one to change the public brief or application form.',
  adminNoListings: 'No opportunities yet.',
  adminNoListingsHint: 'Add a call-out or role to publish it on the jobs site.',
  adminNewListing: 'New opportunity',
  adminEditListing: 'Edit opportunity',
  adminListingSaved: 'Listing saved.',
  adminTitleField: 'Title',
  adminSubtitleField: 'Subtitle',
  adminSlug: 'URL slug',
  adminSlugHint: 'Used in the public URL. You can change this until you save.',
  adminSlugLocked: 'The slug cannot change after the listing is saved, because applications use it.',
  adminKind: 'Type',
  adminContactEmail: 'Contact email',
  adminEmailSubject: 'Email subject',
  adminDeadlineAt: 'Close applications at',
  adminSummary: 'Summary',
  adminGlanceLabel: 'Label',
  adminGlanceValue: 'Value',
  adminAddGlance: 'Add glance row',
  adminBrief: 'Brief',
  adminBlockType: 'Block type',
  adminBlock: {
    paragraphs: 'Paragraphs',
    bullets: 'Bullets',
    numbered: 'Numbered list',
    table: 'Table',
    note: 'Note',
  },
  adminHeading: 'Heading',
  adminParagraphs: 'Paragraphs',
  adminParagraphsHint: 'Leave a blank line between paragraphs.',
  adminListItems: 'List items',
  adminListHint: 'One item per line.',
  adminTableHeaders: 'Column headings',
  adminTableHeadersHint: 'Separate columns with |',
  adminTableRows: 'Rows',
  adminTableRowsHint: 'One row per line. Separate cells with |',
  adminNote: 'Note',
  adminAddBlock: 'Add brief block',
  adminApplicationForm: 'Application form',
  adminSectionTitle: 'Section title',
  adminSectionIntro: 'Section intro',
  adminQuestionLabel: 'Question',
  adminQuestionHelper: 'Helper text',
  adminQuestionRequired: 'Required',
  adminQuestionMultiline: 'Long answer',
  adminAddQuestion: 'Add question',
  adminRemoveQuestion: 'Remove question',
  adminAddSection: 'Add form section',
  adminRemoveSection: 'Remove section',
  adminFooterNote: 'Footer note',
  adminValidationTitle: 'Please enter a title.',
  adminValidationSlug: 'Please enter a URL slug.',
  adminValidationSlugTaken: 'That slug is already used by another listing.',
  notFoundTitle: 'Opportunity not found',
  notFoundBody: 'This listing is not available. It may have been moved or closed.',
  scoring: {
    method: 'How to score',
    markScale: 'What 0–5 means',
    gatesTitle: 'Gates',
    gatesHint:
      'Do not score until these pass. A missing item is a hold, not a low mark. Request it once; if it still does not come, stop.',
    gatePass: 'Pass',
    gateHold: 'Hold',
    gateFail: 'Fail',
    passLooksLike: 'Pass: {{text}}',
    failLooksLike: 'Fail / hold: {{text}}',
    note: 'Note',
    noteRequired: 'Write a sentence for a 1 or a 5.',
    criteriaTitle: 'Weighted criteria',
    criteriaHint: 'Each criterion is marked 0–5. Points = mark ÷ 5 × weight.',
    weight: '{{weight}} pts',
    publishedTest: 'Published test',
    readIn: 'Read it in',
    guidance: 'Guidance',
    points: '{{points}} / {{weight}}',
    decision: 'Decision',
    noDecision: 'Not decided',
    decisions: {
      shortlist: 'Shortlist',
      hold: 'Hold',
      unsuitable: 'Unsuitable offer',
      widen: 'Widen search',
    },
    summary: 'Overall note',
    total: 'Weighted total',
    outOf: '{{total}} / 100',
    toMark: '{{count}} criteria still to mark',
    gatesIncomplete: 'Gates not all checked — total is provisional',
    gatesHeld: 'A gate is on hold — total is provisional',
    gatesFailed: 'A gate has failed — do not appoint',
    unsuitable:
      'Connectedness or transfer is 0–1: record “unsuitable offer” whatever the total.',
    save: 'Save score',
    saving: 'Saving…',
    saved: 'Score saved.',
    saveFailed: 'Could not save the score. Please try again.',
    missingNotes: 'Add a note for every criterion marked 1 or 5 before saving.',
    rate: 'Rate',
    rateTitle: 'Rate {{name}}',
    scoreColumn: 'Score',
    notScored: 'Not scored',
    inProgress: 'In progress',
    markers: 'Markers: {{count}}',
    moderate: 'Markers differ by 2 or more — talk before averaging',
    scoresTitle: 'Scores',
    marker: 'Marker',
    average: 'Average',
    noScores: 'No one has scored this submission yet.',
    scoresLoadFailed: 'Could not load scores.',
    shareTitle: 'Share for scoring',
    shareHint:
      'Send this link and the password to anyone you want to score submissions. They see the submitted packs without contact details, and only their own scores.',
    shareLink: 'Scoring link',
    copyLink: 'Copy link',
    linkCopied: 'Link copied.',
    shareOn: 'Open — password set {{date}}',
    shareOff: 'Closed — set a password to open the link.',
    setPassword: 'Set password',
    changePassword: 'Change password',
    closeLink: 'Close link',
    passwordLabel: 'Password',
    passwordHint:
      'At least 8 characters. Changing it signs out everyone using the old one. Send it separately from the link.',
    passwordTooShort: 'Password must be at least 8 characters.',
    passwordSaved: 'Password saved. The scoring link is open.',
    linkClosed: 'Scoring link closed.',
    accessFailed: 'Could not update the scoring link.',
    reviewTitle: 'Score submissions',
    unlockIntro:
      'Enter the password you were sent. Your name and email label your scores, so you can come back and change them.',
    yourName: 'Your name',
    yourEmail: 'Your email',
    unlock: 'Open submissions',
    unlocking: 'Checking…',
    wrongPassword: 'That password is not right.',
    tooManyAttempts: 'Too many attempts. Try again in 15 minutes.',
    notOpen: 'Scoring is not open for this opportunity.',
    detailsRequired: 'Please enter your name and a valid email address.',
    sessionExpired: 'Your session has expired. Enter the password again.',
    openFailed: 'Could not open the submissions. Please try again.',
    noRubric: 'This opportunity does not have a scoring rubric.',
    scoringAs: 'Scoring as {{name}}',
    signOut: 'Sign out',
    submissions: 'Submissions',
    noSubmissions: 'There are no submitted applications yet.',
    allSubmissions: 'All submissions',
    withheld: 'Withheld from reviewers',
    independent: 'Mark on your own. Only you and Overhear can see your scores.',
    confidential:
      'Confidential. Please do not share, copy or download these applications.',
  },
  validation: {
    nameRequired: 'Please enter your name.',
    emailRequired: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    requiredFields: 'Please complete every required field before submitting.',
    privacyRequired: 'Please confirm you are happy for us to store this application.',
  },
};
